<template>
  <v-autocomplete
    :label="label"
    :value="current"
    :items="candidate"
    :loading="loading"
    item-value="warehouseCd"
    item-text="warehouseName"
    return-object
    :disabled="disabled"
    :rules="rules"
    @change="onSelected"
    clearable
    hide-no-data
    filled
    dense
    :attach="attach"
  ></v-autocomplete>
</template>

<script>
export default {
  name: "StorageField",
  model: { prop: "value", event: "selected" },
  props: {
    label: { type: String, default: "倉庫" },
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    attach: { type: Boolean, default: true },
    rules: { type: Array, default: () => [] },
    param: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: null,
      candidate: [],
      current: null,
    };
  },
  async mounted() {
    await this.setup();
    this.apply(this.value);
  },
  watch: {
    value(value) {
      this.apply(value);
    },
  },
  methods: {
    async setup() {
      try {
        this.loading = true;
        const response = await this.$store.dispatch("stock/storageSearch");
        if (response.data?.contents?.storage) {
          this.candidate = response.data.contents.storage;
        } else {
          this.candidate = [];
        }
      } catch (error) {
        console.error("StorageField::setup", error);
      } finally {
        this.loading = false;
      }
    },
    apply(value) {
      if (value) {
        if (value == this.current?.warehouseCd) {
          // NOP
        } else {
          const current = this.candidate.find((c) => value === c.warehouseCd);
          this.onSelected(current);
        }
      } else {
        this.current = null;
      }
    },
    selected() {
      return this.current;
    },
    onSelected(value) {
      this.current = value;
      if (value) {
        this.$emit("selected", value.warehouseCd);
      } else {
        this.$emit("selected", null);
      }
    },
  },
};
</script>
